<div class="outer-wrapper" *ngIf="loaded" (clickOutside)="close()">
  <div class="nav-wrapper" #navWrapper [class.extended]="showDownloads || showAgenda || showSupport">
    <div class="logo">
      <img class="l1x1" [src]="navigation.logo" [alt]="generalSettings && generalSettings.title" />
      <img class="normal" [src]="navigation.logo" [alt]="generalSettings && generalSettings.title" />
    </div>
    <ul class="nav navbar-nav">
      <li class="nav-item" *ngFor="let link of links">
        <a
          id="navReception"
          *ngIf="link.type === NavigationLinkType.Reception"
          class="nav-link"
          [routerLink]="link.route"
          routerLinkActive="active"
          (click)="loadReception(link)"
        >
          <svg-icon *ngIf="link.icon.endsWith('.svg')" [src]="link.icon" [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon>
          <span *ngIf="!link.icon.includes('.')" class="mat-icons-icon">
            <mat-icon>{{ link.icon }}</mat-icon>
          </span>
          <img *ngIf="!link.icon.endsWith('.svg') && link.icon.includes('.')" [src]="link.icon" [alt]="link.caption" />
          <span class="link" [innerHtml]="link.caption | safeHTML"></span>
        </a>
        <a
          id="navKeynote"
          *ngIf="link.type === NavigationLinkType.Keynote"
          class="nav-link"
          [routerLink]="link.route"
          routerLinkActive="active"
          (click)="changeKeynote(link)"
        >
          <svg-icon *ngIf="link.icon.endsWith('.svg')" [src]="link.icon" [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon>
          <span *ngIf="!link.icon.includes('.')" class="mat-icons-icon">
            <mat-icon>{{ link.icon }}</mat-icon>
          </span>
          <img *ngIf="!link.icon.endsWith('.svg') && link.icon.includes('.')" [src]="link.icon" [alt]="link.caption" />
          <span class="link" [innerHtml]="link.caption | safeHTML"></span>
        </a>
        <a
          id="navWorkshop"
          *ngIf="link.type === NavigationLinkType.Workshop"
          class="nav-link"
          [routerLink]="link.route"
          routerLinkActive="active"
          (click)="loadWorkshop(link)"
        >
          <svg-icon *ngIf="link.icon.endsWith('.svg')" [src]="link.icon" [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon>
          <span *ngIf="!link.icon.includes('.')" class="mat-icons-icon">
            <mat-icon>{{ link.icon }}</mat-icon>
          </span>
          <img *ngIf="!link.icon.endsWith('.svg') && link.icon.includes('.')" [src]="link.icon" [alt]="link.caption" />
          <span class="link" [innerHtml]="link.caption | safeHTML"></span>
        </a>
        <a
          id="navNetworking"
          *ngIf="link.type === NavigationLinkType.Networking"
          class="nav-link"
          [routerLink]="link.route"
          routerLinkActive="active"
          (click)="loadNetworking(link)"
        >
          <svg-icon *ngIf="link.icon.endsWith('.svg')" [src]="link.icon" [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon>
          <span *ngIf="!link.icon.includes('.')" class="mat-icons-icon">
            <mat-icon>{{ link.icon }}</mat-icon>
          </span>
          <img *ngIf="!link.icon.endsWith('.svg') && link.icon.includes('.')" [src]="link.icon" [alt]="link.caption" />
          <span class="link" [innerHtml]="link.caption | safeHTML"></span>
        </a>
        <a
          id="navFair"
          *ngIf="link.type === NavigationLinkType.Fair"
          class="nav-link"
          [routerLink]="link.route"
          routerLinkActive="active"
          (click)="loadFair(link)"
        >
          <svg-icon *ngIf="link.icon.endsWith('.svg')" [src]="link.icon" [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon>
          <span *ngIf="!link.icon.includes('.')" class="mat-icons-icon">
            <mat-icon>{{ link.icon }}</mat-icon>
          </span>
          <img *ngIf="!link.icon.endsWith('.svg') && link.icon.includes('.')" [src]="link.icon" [alt]="link.caption" />
          <span class="link" [innerHtml]="link.caption | safeHTML"></span>
        </a>
        <a
          id="navCollection"
          *ngIf="link.type === NavigationLinkType.Collection"
          class="nav-link"
          [routerLink]="link.route"
          routerLinkActive="active"
          (click)="loadCollection(link)"
        >
          <svg-icon *ngIf="link.icon.endsWith('.svg')" [src]="link.icon" [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"></svg-icon>
          <span *ngIf="!link.icon.includes('.')" class="mat-icons-icon">
            <mat-icon>{{ link.icon }}</mat-icon>
          </span>
          <img *ngIf="!link.icon.endsWith('.svg') && link.icon.includes('.')" [src]="link.icon" [alt]="link.caption" />
          <span class="link" [innerHtml]="link.caption | safeHTML"></span>
        </a>
      </li>
    </ul>
    <div class="placeholder"></div>
    <ul class="ressources">
      <li class="nav-item" id="navAgenda" *ngIf="agenda && agenda.enabled">
        <a class="nav-link" (click)="openAgenda()" [class.active]="showAgenda">
          <!--          <img src="../../../../assets/icons/agenda.png" alt="link.text">-->
          <svg
            id="Capa_1"
            version="1.1"
            x="0px"
            xmlns="http://www.w3.org/2000/svg"
            y="0px"
            viewBox="0 0 511.634 511.634"
            xml:space="preserve"
          >
            <path
              d="M482.513,83.942c-7.225-7.233-15.797-10.85-25.694-10.85h-36.541v-27.41c0-12.56-4.477-23.315-13.422-32.261
              C397.906,4.475,387.157,0,374.591,0h-18.268c-12.565,0-23.318,4.475-32.264,13.422c-8.949,8.945-13.422,19.701-13.422,32.261v27.41
              h-109.63v-27.41c0-12.56-4.475-23.315-13.422-32.261C178.64,4.475,167.886,0,155.321,0H137.05
              c-12.562,0-23.317,4.475-32.264,13.422c-8.945,8.945-13.421,19.701-13.421,32.261v27.41H54.823c-9.9,0-18.464,3.617-25.697,10.85
              c-7.233,7.232-10.85,15.8-10.85,25.697v365.453c0,9.89,3.617,18.456,10.85,25.693c7.232,7.231,15.796,10.849,25.697,10.849h401.989
              c9.897,0,18.47-3.617,25.694-10.849c7.234-7.234,10.852-15.804,10.852-25.693V109.639
              C493.357,99.739,489.743,91.175,482.513,83.942z M137.047,475.088H54.823v-82.23h82.224V475.088z M137.047,374.59H54.823v-91.358
              h82.224V374.59z M137.047,264.951H54.823v-82.223h82.224V264.951z M130.627,134.333c-1.809-1.809-2.712-3.946-2.712-6.423V45.686
              c0-2.474,0.903-4.617,2.712-6.423c1.809-1.809,3.946-2.712,6.423-2.712h18.271c2.474,0,4.617,0.903,6.423,2.712
              c1.809,1.807,2.714,3.949,2.714,6.423v82.224c0,2.478-0.909,4.615-2.714,6.423c-1.807,1.809-3.946,2.712-6.423,2.712H137.05
              C134.576,137.046,132.436,136.142,130.627,134.333z M246.683,475.088h-91.365v-82.23h91.365V475.088z M246.683,374.59h-91.365
              v-91.358h91.365V374.59z M246.683,264.951h-91.365v-82.223h91.365V264.951z M356.323,475.088h-91.364v-82.23h91.364V475.088z
               M356.323,374.59h-91.364v-91.358h91.364V374.59z M356.323,264.951h-91.364v-82.223h91.364V264.951z M349.896,134.333
              c-1.807-1.809-2.707-3.946-2.707-6.423V45.686c0-2.474,0.9-4.617,2.707-6.423c1.808-1.809,3.949-2.712,6.427-2.712h18.268
              c2.478,0,4.617,0.903,6.427,2.712c1.808,1.807,2.707,3.949,2.707,6.423v82.224c0,2.478-0.903,4.615-2.707,6.423
              c-1.807,1.809-3.949,2.712-6.427,2.712h-18.268C353.846,137.046,351.697,136.142,349.896,134.333z M456.812,475.088h-82.228v-82.23
              h82.228V475.088z M456.812,374.59h-82.228v-91.358h82.228V374.59z M456.812,264.951h-82.228v-82.223h82.228V264.951z"
            />
          </svg>
          <span class="link" [innerHtml]="navigation.captionAgenda | safeHTML"></span>
        </a>
      </li>
      <li *ngIf="navigation.showDownloads" class="nav-item" id="navDownloads">
        <a class="nav-link" (click)="openDownloads()" [class.active]="showDownloads">
          <!--          <img src="../../../../assets/icons/download.png" alt="link.text">-->
          <svg
            id="Capa_1"
            version="1.1"
            x="0px"
            xmlns="http://www.w3.org/2000/svg"
            y="0px"
            viewBox="0 0 475.078 475.077"
            xml:space="preserve"
          >
            <path
              d="M467.083,318.627c-5.324-5.328-11.8-7.994-19.41-7.994H315.195l-38.828,38.827c-11.04,10.657-23.982,15.988-38.828,15.988
              c-14.843,0-27.789-5.324-38.828-15.988l-38.543-38.827H27.408c-7.612,0-14.083,2.669-19.414,7.994
              C2.664,323.955,0,330.427,0,338.044v91.358c0,7.614,2.664,14.085,7.994,19.414c5.33,5.328,11.801,7.99,19.414,7.99h420.266
              c7.61,0,14.086-2.662,19.41-7.99c5.332-5.329,7.994-11.8,7.994-19.414v-91.358C475.078,330.427,472.416,323.955,467.083,318.627z
               M360.025,414.841c-3.621,3.617-7.905,5.424-12.854,5.424s-9.227-1.807-12.847-5.424c-3.614-3.617-5.421-7.898-5.421-12.844
              c0-4.948,1.807-9.236,5.421-12.847c3.62-3.62,7.898-5.431,12.847-5.431s9.232,1.811,12.854,5.431
              c3.613,3.61,5.421,7.898,5.421,12.847C365.446,406.942,363.638,411.224,360.025,414.841z M433.109,414.841
              c-3.614,3.617-7.898,5.424-12.848,5.424c-4.948,0-9.229-1.807-12.847-5.424c-3.613-3.617-5.42-7.898-5.42-12.844
              c0-4.948,1.807-9.236,5.42-12.847c3.617-3.62,7.898-5.431,12.847-5.431c4.949,0,9.233,1.811,12.848,5.431
              c3.617,3.61,5.427,7.898,5.427,12.847C438.536,406.942,436.729,411.224,433.109,414.841z"
            />
            <path
              d="M224.692,323.479c3.428,3.613,7.71,5.421,12.847,5.421c5.141,0,9.418-1.808,12.847-5.421l127.907-127.908
                c5.899-5.519,7.234-12.182,3.997-19.986c-3.23-7.421-8.847-11.132-16.844-11.136h-73.091V36.543c0-4.948-1.811-9.231-5.421-12.847
                c-3.62-3.617-7.901-5.426-12.847-5.426h-73.096c-4.946,0-9.229,1.809-12.847,5.426c-3.615,3.616-5.424,7.898-5.424,12.847V164.45
                h-73.089c-7.998,0-13.61,3.715-16.846,11.136c-3.234,7.801-1.903,14.467,3.999,19.986L224.692,323.479z"
            />
          </svg>
          <span class="link" [innerHtml]="navigation.captionDownloads | safeHTML"></span>
        </a>
      </li>
      <li *ngIf="navigation.showSupport" class="nav-item" id="navSupport">
        <a class="nav-link" (click)="openSupport()" [class.active]="showSupport">
          <!--          <img src="../../../../assets/icons/download.png" alt="link.text">-->
          <svg
            id="Capa_1"
            version="1.1"
            x="0px"
            xmlns="http://www.w3.org/2000/svg"
            y="0px"
            viewBox="0 0 365.442 365.442"
            xml:space="preserve"
          >
            <path
              d="M212.994,274.074h-68.522c-3.042,0-5.708,1.149-7.992,3.429c-2.286,2.286-3.427,4.948-3.427,7.994v68.525
              c0,3.046,1.145,5.712,3.427,7.994c2.284,2.279,4.947,3.426,7.992,3.426h68.522c3.042,0,5.715-1.144,7.99-3.426
              c2.29-2.282,3.433-4.948,3.433-7.994v-68.525c0-3.046-1.14-5.708-3.433-7.994C218.709,275.217,216.036,274.074,212.994,274.074z"
            />
            <path
              d="M302.935,68.951c-7.806-14.378-17.891-26.506-30.266-36.406c-12.367-9.896-26.271-17.799-41.685-23.697
                  C215.567,2.952,200.246,0,185.016,0C127.157,0,83,25.315,52.544,75.946c-1.521,2.473-2.046,5.137-1.571,7.993
                  c0.478,2.852,1.953,5.232,4.427,7.135l46.824,35.691c2.474,1.52,4.854,2.281,7.139,2.281c3.427,0,6.375-1.525,8.852-4.57
                  c13.702-17.128,23.887-28.072,30.548-32.833c8.186-5.518,18.461-8.276,30.833-8.276c11.61,0,21.838,3.046,30.692,9.132
                  c8.85,6.092,13.271,13.135,13.271,21.129c0,8.942-2.375,16.178-7.135,21.698c-4.757,5.518-12.754,10.845-23.986,15.986
                  c-14.842,6.661-28.457,16.988-40.823,30.978c-12.375,13.991-18.558,28.885-18.558,44.682v12.847c0,3.62,0.994,7.187,2.996,10.708
                  c2,3.524,4.425,5.283,7.282,5.283h68.521c3.046,0,5.708-1.472,7.994-4.432c2.279-2.942,3.426-6.036,3.426-9.267
                  c0-4.757,2.617-11.14,7.847-19.13c5.235-7.994,11.752-14.186,19.562-18.565c7.419-4.186,13.219-7.56,17.411-10.133
                  c4.196-2.566,9.664-6.715,16.423-12.421c6.756-5.712,11.991-11.375,15.698-16.988c3.713-5.614,7.046-12.896,9.996-21.844
                  c2.956-8.945,4.428-18.558,4.428-28.835C314.639,98.397,310.734,83.314,302.935,68.951z"
            />
          </svg>
          <span class="link" [innerHtml]="navigation.captionSupport | safeHTML"></span>
        </a>
      </li>
      <li class="nav-item" *ngIf="navigation.showCustomButton">
        <a class="nav-link" [href]="navigation.customButtonLink" target="_blank">
          <!--          <img src="../../../../assets/icons/download.png" alt="link.text">-->
          <svg
            id="Capa_1"
            enable-background="new 0 0 512 512"
            height="512"
            viewBox="0 0 512 512"
            width="512"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path
                d="m446.604 124.392-119.996-119.997c-2.846-2.847-6.735-4.395-10.608-4.395h-210c-24.813 0-45
                    20.187-45 45v422c0 24.813 20.187 45 45 45h300c24.813 0 45-20.187 45-45v-332c0-4.116-1.743-7.957-4.396-10.608zm-115.604-73.179
                    68.787 68.787h-53.787c-8.271 0-15-6.729-15-15zm75 430.787h-300c-8.271 0-15-6.729-15-15v-422c0-8.271 6.729-15 15-15h195v75c0
                    24.813 20.187 45 45 45h75v317c0 8.271-6.729 15-15 15z"
              />
              <path
                d="m346 242h-150c-8.284 0-15 6.716-15 15s6.716 15 15
                    15h150c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
              />
              <path
                d="m346 302h-150c-8.284 0-15 6.716-15 15s6.716 15 15 15h150c8.284 0
                    15-6.716 15-15s-6.716-15-15-15z"
              />
              <path
                d="m346 362h-150c-8.284 0-15 6.716-15 15s6.716 15 15 15h150c8.284 0 15-6.716
                    15-15s-6.716-15-15-15z"
              />
              <circle cx="136" cy="257" r="15" />
              <circle cx="136" cy="317" r="15" />
              <circle cx="136" cy="377" r="15" />
            </g>
          </svg>
          <span class="link" [innerHtml]="navigation.customButtonText | safeHTML"></span>
        </a>
      </li>
      <div class="bottom" [class.activeBottom]="showAgenda || showDownloads || showSupport">
        <a class="impressum" [href]="navigation.impressumLink" target="_blank" [innerHtml]="navigation.impressumText | safeHTML"></a>
        <button mat-button matTooltip="Logout" (click)="logout()">
          Logout
        </button>
      </div>
      <li *ngIf="generalSettings && generalSettings.showOlark" class="nav-item olark"></li>
    </ul>
  </div>
  <div *ngIf="showAgenda && agenda && agenda.enabled" class="agenda-wrapper mobile-support">
    <div class="close" (click)="close()">
      <mat-icon> menu_open</mat-icon>
      <p>{{ navigation.captionClose }}</p>
    </div>
    <mat-toolbar>
      <span class="supportMobileCaption" [innerHtml]="navigation.captionAgenda"></span>
      <button class="supportClose" (click)="close()" mat-mini-fab>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
    <!-- AGENDA -->
    <app-agenda></app-agenda>
  </div>
  <div *ngIf="showDownloads" class="downloads-wrapper mobile-support">
    <div class="close" (click)="close()">
      <mat-icon> menu_open</mat-icon>
      <p [innerHtml]="navigation.captionClose | safeHTML"></p>
    </div>
    <mat-toolbar>
      <span class="supportMobileCaption" [innerHtml]="navigation.captionDownloads"></span>
      <button class="supportClose" (click)="close()" mat-mini-fab>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
    <app-downloads></app-downloads>
  </div>
  <div *ngIf="showSupport" class="support-wrapper mobile-support">
    <div class="close" (click)="close()">
      <mat-icon> menu_open</mat-icon>
      <p [innerHtml]="navigation.captionClose | safeHTML"></p>
    </div>
    <mat-toolbar>
      <span class="supportMobileCaption" [innerHtml]="navigation.captionSupport"></span>
      <button class="supportClose" (click)="close()" mat-mini-fab>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
    <app-support></app-support>
  </div>
  <mat-toolbar (clickOutside)="closeSubmenu()" class="mobile-top-nav" *ngIf="!booth">
    <mat-toolbar-row>
      <img *ngIf="!searching" [alt]="generalSettings && generalSettings.title" [src]="navigation.logo" />
      <div *ngIf="!searching" class="placeholder"></div>
      <div *ngIf="searching && (expo || collection)" style="width: 100%;">
        <button mat-icon-button (click)="searching = !searching">
          <mat-icon style="font-size: 37px; position: relative; right: 7px;">chevron_left</mat-icon>
        </button>
        <mat-form-field floatLabel="never" style="width: calc(100% - 40px);">
          <mat-label>{{ searchText }}</mat-label>
          <input [formControl]="searchValue" matInput />
          <mat-icon style="cursor: pointer; top: 6px; position: relative;" (click)="searchValue.setValue('')" matSuffix>clear</mat-icon>
        </mat-form-field>
      </div>
      <button *ngIf="!searching && (expo || collection)" (click)="searching = !searching" mat-icon-button>
        <mat-icon>search</mat-icon>
      </button>
      <button
        (click)="toggleSubmenu()"
        mat-icon-button
        *ngIf="
          !searching && ((agenda && agenda.enabled) || navigation.showDownloads || navigation.showSupport || navigation.showCustomButton)
        "
      >
        <mat-icon>menu</mat-icon>
      </button>
    </mat-toolbar-row>
    <mat-toolbar-row (click)="openAgenda()" *ngIf="agenda && agenda.enabled && submenu" class="submenu">
      <div class="separator"></div>
      <div class="content">
        <svg
          id="Capa_1"
          version="1.1"
          viewBox="0 0 511.634 511.634"
          x="0px"
          xml:space="preserve"
          xmlns="http://www.w3.org/2000/svg"
          y="0px"
        >
          <path
            d="M482.513,83.942c-7.225-7.233-15.797-10.85-25.694-10.85h-36.541v-27.41c0-12.56-4.477-23.315-13.422-32.261
              C397.906,4.475,387.157,0,374.591,0h-18.268c-12.565,0-23.318,4.475-32.264,13.422c-8.949,8.945-13.422,19.701-13.422,32.261v27.41
              h-109.63v-27.41c0-12.56-4.475-23.315-13.422-32.261C178.64,4.475,167.886,0,155.321,0H137.05
              c-12.562,0-23.317,4.475-32.264,13.422c-8.945,8.945-13.421,19.701-13.421,32.261v27.41H54.823c-9.9,0-18.464,3.617-25.697,10.85
              c-7.233,7.232-10.85,15.8-10.85,25.697v365.453c0,9.89,3.617,18.456,10.85,25.693c7.232,7.231,15.796,10.849,25.697,10.849h401.989
              c9.897,0,18.47-3.617,25.694-10.849c7.234-7.234,10.852-15.804,10.852-25.693V109.639
              C493.357,99.739,489.743,91.175,482.513,83.942z M137.047,475.088H54.823v-82.23h82.224V475.088z M137.047,374.59H54.823v-91.358
              h82.224V374.59z M137.047,264.951H54.823v-82.223h82.224V264.951z M130.627,134.333c-1.809-1.809-2.712-3.946-2.712-6.423V45.686
              c0-2.474,0.903-4.617,2.712-6.423c1.809-1.809,3.946-2.712,6.423-2.712h18.271c2.474,0,4.617,0.903,6.423,2.712
              c1.809,1.807,2.714,3.949,2.714,6.423v82.224c0,2.478-0.909,4.615-2.714,6.423c-1.807,1.809-3.946,2.712-6.423,2.712H137.05
              C134.576,137.046,132.436,136.142,130.627,134.333z M246.683,475.088h-91.365v-82.23h91.365V475.088z M246.683,374.59h-91.365
              v-91.358h91.365V374.59z M246.683,264.951h-91.365v-82.223h91.365V264.951z M356.323,475.088h-91.364v-82.23h91.364V475.088z
               M356.323,374.59h-91.364v-91.358h91.364V374.59z M356.323,264.951h-91.364v-82.223h91.364V264.951z M349.896,134.333
              c-1.807-1.809-2.707-3.946-2.707-6.423V45.686c0-2.474,0.9-4.617,2.707-6.423c1.808-1.809,3.949-2.712,6.427-2.712h18.268
              c2.478,0,4.617,0.903,6.427,2.712c1.808,1.807,2.707,3.949,2.707,6.423v82.224c0,2.478-0.903,4.615-2.707,6.423
              c-1.807,1.809-3.949,2.712-6.427,2.712h-18.268C353.846,137.046,351.697,136.142,349.896,134.333z M456.812,475.088h-82.228v-82.23
              h82.228V475.088z M456.812,374.59h-82.228v-91.358h82.228V374.59z M456.812,264.951h-82.228v-82.223h82.228V264.951z"
          />
        </svg>
        <span [innerHtml]="navigation.captionAgenda | safeHTML"></span>
        <div class="placeholder"></div>
      </div>
    </mat-toolbar-row>
    <mat-divider></mat-divider>
    <mat-toolbar-row (click)="openDownloads()" *ngIf="submenu && navigation.showDownloads" class="submenu">
      <div class="separator"></div>
      <div class="content">
        <svg
          id="Capa_1"
          version="1.1"
          viewBox="0 0 475.078 475.077"
          x="0px"
          xml:space="preserve"
          xmlns="http://www.w3.org/2000/svg"
          y="0px"
        >
          <path
            d="M467.083,318.627c-5.324-5.328-11.8-7.994-19.41-7.994H315.195l-38.828,38.827c-11.04,10.657-23.982,15.988-38.828,15.988
              c-14.843,0-27.789-5.324-38.828-15.988l-38.543-38.827H27.408c-7.612,0-14.083,2.669-19.414,7.994
              C2.664,323.955,0,330.427,0,338.044v91.358c0,7.614,2.664,14.085,7.994,19.414c5.33,5.328,11.801,7.99,19.414,7.99h420.266
              c7.61,0,14.086-2.662,19.41-7.99c5.332-5.329,7.994-11.8,7.994-19.414v-91.358C475.078,330.427,472.416,323.955,467.083,318.627z
               M360.025,414.841c-3.621,3.617-7.905,5.424-12.854,5.424s-9.227-1.807-12.847-5.424c-3.614-3.617-5.421-7.898-5.421-12.844
              c0-4.948,1.807-9.236,5.421-12.847c3.62-3.62,7.898-5.431,12.847-5.431s9.232,1.811,12.854,5.431
              c3.613,3.61,5.421,7.898,5.421,12.847C365.446,406.942,363.638,411.224,360.025,414.841z M433.109,414.841
              c-3.614,3.617-7.898,5.424-12.848,5.424c-4.948,0-9.229-1.807-12.847-5.424c-3.613-3.617-5.42-7.898-5.42-12.844
              c0-4.948,1.807-9.236,5.42-12.847c3.617-3.62,7.898-5.431,12.847-5.431c4.949,0,9.233,1.811,12.848,5.431
              c3.617,3.61,5.427,7.898,5.427,12.847C438.536,406.942,436.729,411.224,433.109,414.841z"
          />
          <path
            d="M224.692,323.479c3.428,3.613,7.71,5.421,12.847,5.421c5.141,0,9.418-1.808,12.847-5.421l127.907-127.908
                c5.899-5.519,7.234-12.182,3.997-19.986c-3.23-7.421-8.847-11.132-16.844-11.136h-73.091V36.543c0-4.948-1.811-9.231-5.421-12.847
                c-3.62-3.617-7.901-5.426-12.847-5.426h-73.096c-4.946,0-9.229,1.809-12.847,5.426c-3.615,3.616-5.424,7.898-5.424,12.847V164.45
                h-73.089c-7.998,0-13.61,3.715-16.846,11.136c-3.234,7.801-1.903,14.467,3.999,19.986L224.692,323.479z"
          />
        </svg>
        <span [innerHtml]="navigation.captionDownloads | safeHTML"></span>
        <div class="placeholder"></div>
      </div>
    </mat-toolbar-row>
    <mat-toolbar-row (click)="openSupport()" *ngIf="submenu && navigation.showSupport" class="submenu">
      <div class="separator"></div>
      <div class="content">
        <svg
          id="Capa_1"
          version="1.1"
          viewBox="0 0 365.442 365.442"
          x="0px"
          xml:space="preserve"
          xmlns="http://www.w3.org/2000/svg"
          y="0px"
        >
          <path
            d="M212.994,274.074h-68.522c-3.042,0-5.708,1.149-7.992,3.429c-2.286,2.286-3.427,4.948-3.427,7.994v68.525
              c0,3.046,1.145,5.712,3.427,7.994c2.284,2.279,4.947,3.426,7.992,3.426h68.522c3.042,0,5.715-1.144,7.99-3.426
              c2.29-2.282,3.433-4.948,3.433-7.994v-68.525c0-3.046-1.14-5.708-3.433-7.994C218.709,275.217,216.036,274.074,212.994,274.074z"
          />
          <path
            d="M302.935,68.951c-7.806-14.378-17.891-26.506-30.266-36.406c-12.367-9.896-26.271-17.799-41.685-23.697
                  C215.567,2.952,200.246,0,185.016,0C127.157,0,83,25.315,52.544,75.946c-1.521,2.473-2.046,5.137-1.571,7.993
                  c0.478,2.852,1.953,5.232,4.427,7.135l46.824,35.691c2.474,1.52,4.854,2.281,7.139,2.281c3.427,0,6.375-1.525,8.852-4.57
                  c13.702-17.128,23.887-28.072,30.548-32.833c8.186-5.518,18.461-8.276,30.833-8.276c11.61,0,21.838,3.046,30.692,9.132
                  c8.85,6.092,13.271,13.135,13.271,21.129c0,8.942-2.375,16.178-7.135,21.698c-4.757,5.518-12.754,10.845-23.986,15.986
                  c-14.842,6.661-28.457,16.988-40.823,30.978c-12.375,13.991-18.558,28.885-18.558,44.682v12.847c0,3.62,0.994,7.187,2.996,10.708
                  c2,3.524,4.425,5.283,7.282,5.283h68.521c3.046,0,5.708-1.472,7.994-4.432c2.279-2.942,3.426-6.036,3.426-9.267
                  c0-4.757,2.617-11.14,7.847-19.13c5.235-7.994,11.752-14.186,19.562-18.565c7.419-4.186,13.219-7.56,17.411-10.133
                  c4.196-2.566,9.664-6.715,16.423-12.421c6.756-5.712,11.991-11.375,15.698-16.988c3.713-5.614,7.046-12.896,9.996-21.844
                  c2.956-8.945,4.428-18.558,4.428-28.835C314.639,98.397,310.734,83.314,302.935,68.951z"
          />
        </svg>
        <span [innerHtml]="navigation.captionSupport | safeHTML"></span>
        <div class="placeholder"></div>
      </div>
    </mat-toolbar-row>
    <mat-toolbar-row *ngIf="submenu && navigation.showCustomButton" class="submenu">
      <div class="separator"></div>
      <a [href]="navigation.customButtonLink" class="content" target="_blank">
        <svg enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
          <g>
            <path
              d="m446.604 124.392-119.996-119.997c-2.846-2.847-6.735-4.395-10.608-4.395h-210c-24.813 0-45
                    20.187-45 45v422c0 24.813 20.187 45 45 45h300c24.813 0 45-20.187 45-45v-332c0-4.116-1.743-7.957-4.396-10.608zm-115.604-73.179
                    68.787 68.787h-53.787c-8.271 0-15-6.729-15-15zm75 430.787h-300c-8.271 0-15-6.729-15-15v-422c0-8.271 6.729-15 15-15h195v75c0
                    24.813 20.187 45 45 45h75v317c0 8.271-6.729 15-15 15z"
            />
            <path
              d="m346 242h-150c-8.284 0-15 6.716-15 15s6.716 15 15
                    15h150c8.284 0 15-6.716 15-15s-6.716-15-15-15z"
            />
            <path
              d="m346 302h-150c-8.284 0-15 6.716-15 15s6.716 15 15 15h150c8.284 0
                    15-6.716 15-15s-6.716-15-15-15z"
            />
            <path
              d="m346 362h-150c-8.284 0-15 6.716-15 15s6.716 15 15 15h150c8.284 0 15-6.716
                    15-15s-6.716-15-15-15z"
            />
            <circle cx="136" cy="257" r="15" />
            <circle cx="136" cy="317" r="15" />
            <circle cx="136" cy="377" r="15" />
          </g>
        </svg>
        <span [innerHtml]="navigation.customButtonText | safeHTML"></span>
        <div class="placeholder"></div>
      </a>
    </mat-toolbar-row>
    <mat-toolbar-row *ngIf="submenu" class="submenu">
      <div class="activeBottom">
        <a
          class="impressum"
          mat-button
          [href]="navigation.impressumLink"
          target="_blank"
          [innerHtml]="navigation.impressumText | safeHTML"
        ></a>
        <button mat-button matTooltip="Logout" (click)="logout()">
          Logout
        </button>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</div>
